import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AppDialogsService } from '@/app/services/app-dialogs.service';

@Component({
    selector: 'app-feedback-button',
    template: `
        <button mat-button *ngIf="!placeholder" (click)="openFeedback()">
            Feedback
            <mat-icon> feedback </mat-icon>
        </button>
        <button mat-button disabled *ngIf="placeholder">
            <egov-text-ui-placeholder> Feedback </egov-text-ui-placeholder>
            <mat-icon>
                <egov-shape-ui-placeholder shape="circle"></egov-shape-ui-placeholder>
            </mat-icon>
        </button>
    `,
    styleUrls: ['./feedback-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeedbackButtonComponent
{
    constructor
    (
        // Dependencies

        private readonly dialogs: AppDialogsService,
    )
    {}


    // Customization

    @Input() protected placeholder = false;


    // Actions

    protected openFeedback()
    {
        this.dialogs.openFeedback();
    }
}
